if (!customElements.get('cotigo-symbol-explorer')) {
  customElements.define('cotigo-symbol-explorer', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const initial = this.querySelector('[data-explorer-choice][aria-pressed="true"]') || this.querySelector('[data-explorer-choice]');
      if (initial) this.select(initial, false);
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-explorer-choice]');
        if (button && button.closest('cotigo-symbol-explorer') === this) this.select(button, true);
      }, options);
      this.addEventListener('keydown', (event) => {
        const button = event.target.closest('[data-explorer-choice]');
        if (!button || button.closest('cotigo-symbol-explorer') !== this) return;
        const buttons = [...this.querySelectorAll('[data-explorer-choice]')];
        const index = buttons.indexOf(button);
        const columns = getComputedStyle(button.parentElement).gridTemplateColumns.split(' ').length;
        let next;
        if (event.key === 'ArrowRight') next = index + 1;
        if (event.key === 'ArrowLeft') next = index - 1;
        if (event.key === 'ArrowDown') next = index + columns;
        if (event.key === 'ArrowUp') next = index - columns;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = buttons.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        buttons[Math.max(0, Math.min(buttons.length - 1, next))].focus();
      }, options);
      document.addEventListener('shopify:block:select', (event) => {
        const button = [...this.querySelectorAll('[data-explorer-choice]')].find((item) => item.dataset.blockId === event.detail?.blockId);
        if (button) this.select(button, false);
      }, options);
    }
    disconnectedCallback() {
      this.controller?.abort();
    }
    select(button, reveal) {
      const id = button.getAttribute('aria-controls');
      let active;
      this.querySelectorAll('[data-explorer-choice]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
      this.querySelectorAll('[data-explorer-panel]').forEach((panel) => {
        panel.hidden = panel.id !== id;
        if (!panel.hidden) active = panel;
      });
      const status = this.querySelector('[data-explorer-status]');
      if (status) status.textContent = button.textContent.trim();
      if (reveal && active && !this.classList.contains('cotigo-explorer--sidebar') && matchMedia('(max-width: 749px)').matches && !window.Shopify?.designMode) {
        const top = active.getBoundingClientRect().top;
        if (top > window.innerHeight - 100) {
          active.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }
      }
    }
  });
}
